"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const redux_1 = require("redux");
const react_redux_1 = require("react-redux");
const moment = require("moment");
const events_1 = require("@dialogexe/cw-website-store/events");
const LandScapeCard_1 = require("@dialogexe/cw-component-landscape-card/LandScapeCard");
const icons_1 = require("@dialogexe/cw-asset-provider/icons");
const cw_component_title_1 = require("@dialogexe/cw-component-title");
const Spinner_1 = require("./Spinner");
const marked_ts_1 = require("marked-ts");
require("moment/locale/nn");
require("moment/locale/nb");
class CultureProgram extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showSpinner: true,
            selectedCategory: null,
            selectedPeriod: { month: "", year: "" },
            selectedLocation: null
        };
        this.setStateFromParams = () => {
            let arrangementTypeParam = "";
            let monthParam = "";
            let yearParam = "";
            let locationParam = "";
            if (typeof window !== 'undefined') {
                const url = new URL(window.location.href);
                arrangementTypeParam = url.searchParams.get("event") ? url.searchParams.get("event") : "";
                monthParam = url.searchParams.get("month") ? url.searchParams.get("month") : "";
                yearParam = url.searchParams.get("year") ? url.searchParams.get("year") : "";
                locationParam = url.searchParams.get("location") ? url.searchParams.get("location") : "";
            }
            this.setState({ selectedCategory: arrangementTypeParam, selectedPeriod: { month: monthParam, year: yearParam }, selectedLocation: locationParam });
        };
        this.createMarkup = (content) => {
            return { __html: content };
        };
        this.translateToNyNorsk = (value) => {
            switch (value) {
                case 'Konserter':
                    return 'Konsertar';
                case 'Annet':
                    return 'Anna';
                case 'konferanser':
                    return 'konferansar';
                case 'Foredrag/konferanser':
                    return 'Foredrag/konferansar';
                default:
                    return value;
            }
        };
        this.isBetweenFilterDates = (date) => {
            if (!moment(date).isValid()) {
                return false;
            }
            const period = moment(date);
            const { fromDate, toDate } = this.getDate();
            return period.isBetween(moment(fromDate).startOf('day'), moment(toDate).startOf('day'), null, '[]');
        };
        this.renderMothSelected = () => {
            return (React.createElement("h2", null, this.state.selectedPeriod && this.state.selectedPeriod.month !== "" && this.getSelectedPeriod(this.state.selectedPeriod)));
        };
        this.getSelectedPeriod = (period) => {
            return `${moment().month(period.month).format("MMMM")} ${moment().year(period.year).format("YYYY")}`;
        };
        this.getSelectedPeriodValue = (period) => {
            return `${period.month}-${period.year}`;
        };
        this.getPeriods = (events) => {
            let periods = [];
            events.forEach(event => {
                const month = moment(event.begin).month();
                const year = moment(event.begin).year();
                const value = { month, year };
                const find = periods.find(p => p.month === value.month && p.year === value.year);
                if (!find) {
                    periods.push(value);
                }
            });
            return periods;
        };
        this.getLocations = (events) => {
            const locationSet = new Set();
            events.map(event => {
                event.tickets.forEach(ticket => locationSet.add(ticket.location));
            });
            return Array.from(locationSet.values());
        };
        this.constructQueryParams = () => {
            const { selectedCategory, selectedPeriod, selectedLocation } = this.state;
            let url = `${window.location.pathname}?`;
            let flag = false;
            if (selectedCategory) {
                url = `${url}event=${selectedCategory}`;
                flag = true;
            }
            if (selectedPeriod.month) {
                if (flag) {
                    url = `${url}&month=${selectedPeriod.month}&year=${selectedPeriod.year}`;
                }
                else {
                    url = `${url}month=${selectedPeriod.month}&year=${selectedPeriod.year}`;
                    flag = true;
                }
            }
            if (selectedLocation) {
                if (flag) {
                    url = `${url}&location=${selectedLocation} `;
                }
                else {
                    url = `${url}location=${selectedLocation} `;
                }
            }
            return url;
        };
        this.updateUrlParam = () => {
            let path = '#';
            if (typeof window !== 'undefined') {
                path = this.constructQueryParams();
                window.history.replaceState(null, "", path);
            }
        };
        this.onCategorySelect = (e) => {
            this.setState({ selectedCategory: e.target.value }, () => {
                this.updateUrlParam();
            });
        };
        this.onPeriodSelect = (e) => {
            const splitValues = e.target.value.split("-");
            this.setState({ selectedPeriod: { month: splitValues[0], year: splitValues[1] } }, () => {
                this.updateUrlParam();
            });
        };
        this.onLocationSelect = (e) => {
            const location = e.target.value;
            this.setState({ selectedLocation: location }, () => {
                this.updateUrlParam();
            });
        };
        this.filterByGiveFilterDates = (events) => {
            const hasFromOrToDateFilter = this.hasFromOrToDateFilter();
            if (!hasFromOrToDateFilter) {
                return events;
            }
            events.forEach(event => {
                this.filterEventTickets(event)
                    .forEach(ticket => {
                    event = { ...event, date: ticket.date, tickets: [] };
                    if (this.isBetweenFilterDates(ticket.date)) {
                        event = { ...event, tickets: [...event.ticket] };
                    }
                });
            });
            return events;
        };
        this.getDate = () => {
            const { from, to } = this.props.filter;
            let fromDate = moment();
            let toDate = moment().add(4, 'years');
            if (from && from.trim() !== "") {
                fromDate = from;
            }
            if (to && to.trim() !== "") {
                toDate = to;
            }
            return {
                fromDate: moment(fromDate, 'YYYY-MM-DD'),
                toDate: moment(toDate, 'YYYY-MM-DD')
            };
        };
        const preferredLanguage = props.preferredLanguage ? props.preferredLanguage : 'nb';
        moment.locale(preferredLanguage);
        marked_ts_1.Marked.setOptions({
            gfm: true,
            tables: true,
            breaks: false,
            pedantic: false,
            sanitize: false,
            smartLists: true,
            smartypants: false
        });
    }
    componentDidMount() {
        let ids = [];
        this.props.events.forEach(e => { ids = ids.concat(e.tickets.map(t => t.id)); });
        this.props.eventActions.fetchEvents(ids);
        this.setStateFromParams();
        if (this.props.events) {
            return this.setState({ showSpinner: false });
        }
    }
    render() {
        if (this.state.showSpinner) {
            return (React.createElement("div", { className: "CultureProgram" },
                React.createElement(Spinner_1.Spinner, null)));
        }
        const { title, subtitle, limit, filter } = this.props;
        let events = this.getFilteredEvents();
        events = this.sortEventsByTicketStartDate(events);
        const filterEvents = limit ? events.slice(0, limit) : events;
        const markedContent = marked_ts_1.Marked.parse(subtitle);
        return (React.createElement("div", { className: "CultureProgram" },
            title && (React.createElement(cw_component_title_1.default, { text: title })),
            subtitle && (React.createElement("div", { className: "subtitle" },
                React.createElement("div", { dangerouslySetInnerHTML: this.createMarkup(markedContent) }))),
            filter && filter.display && this.renderFilter(),
            this.renderEvents(filterEvents)));
    }
    renderEvents(events) {
        const { preferredLanguage, showMoreLinkTitle, showMoreLinkUrl } = this.props;
        if (events.length === 0) {
            return (React.createElement("div", { className: "level is-center" },
                React.createElement("h2", null, "Ingen arrangement er lagt til for \u00F8yeblikket.")));
        }
        return (React.createElement("div", { className: "events" },
            events.map((event, index) => (React.createElement(LandScapeCard_1.default, { key: index, image: event.image, title: event.title, description: event.description, link: event.link, features: event.features, tickets: this.filterEventTickets(event), preferredLanguage: preferredLanguage }))),
            showMoreLinkTitle && showMoreLinkUrl && (React.createElement("div", { className: "level is-flex-end" },
                React.createElement("a", { href: showMoreLinkUrl, className: "show-more" }, showMoreLinkTitle)))));
    }
    hasFromOrToDateFilter() {
        if (this.props.filter) {
            return Boolean(this.props.filter.from) || Boolean(this.props.filter.to);
        }
        return false;
    }
    ;
    renderFilter() {
        const { events } = this.props;
        const categories = this.getDistinctCategories();
        if (categories.length <= 1) {
            return (React.createElement("div", null));
        }
        return (React.createElement("div", null,
            React.createElement("div", { className: "filter" },
                this.renderCategoryDropDown(categories),
                this.renderMonthDropDown(events),
                this.renderLocationDropDown(events)),
            React.createElement("div", { className: "filter-chosen" }, this.renderMothSelected())));
    }
    renderCategoryDropDown(categories) {
        return (React.createElement("nav", { className: "drop-down-filter" },
            React.createElement("div", { className: "input is-wide" },
                React.createElement("select", { onChange: this.onCategorySelect, value: this.state.selectedCategory },
                    React.createElement("option", { value: "" }, "Velg kategori"),
                    categories.map((category) => (React.createElement("option", { key: category.value, value: category.value }, category.label)))),
                React.createElement("i", null,
                    React.createElement("img", { src: icons_1.arrowheadDownIcon, alt: "" })))));
    }
    renderMonthDropDown(events) {
        const periods = this.getPeriods(events);
        return (React.createElement("nav", { className: "drop-down-filter" },
            React.createElement("div", { className: "input is-wide" },
                React.createElement("select", { onChange: this.onPeriodSelect, value: this.getSelectedPeriodValue(this.state.selectedPeriod) },
                    React.createElement("option", { value: "" }, "Velg m\u00E5ned"),
                    periods.map((period, index) => (React.createElement("option", { key: index, value: this.getSelectedPeriodValue(period) }, this.getSelectedPeriod(period))))),
                React.createElement("i", { className: "icon" },
                    React.createElement("img", { src: icons_1.arrowheadDownIcon, alt: "" })))));
    }
    renderLocationDropDown(events) {
        const locations = this.getLocations(events);
        return (React.createElement("nav", { className: "drop-down-filter" },
            React.createElement("div", { className: "input is-wide" },
                React.createElement("select", { onChange: this.onLocationSelect, value: this.state.selectedLocation },
                    React.createElement("option", { value: "" }, "Velg spillested"),
                    locations.map(location => (React.createElement("option", { key: location, value: location }, location)))),
                React.createElement("i", { className: "icon" },
                    React.createElement("img", { src: icons_1.arrowheadDownIcon, alt: "" })))));
    }
    getDistinctCategories() {
        const { events, preferredLanguage } = this.props;
        let categories = [];
        events.forEach(event => {
            const translatedCategory = preferredLanguage === 'nn' ? this.translateToNyNorsk(event.category) : event.category;
            categories[event.category] = { value: event.category, label: translatedCategory };
        });
        return Object.values(categories);
    }
    isEventInSelectedLocation(event) {
        return event.tickets.some(ticket => ticket.location === this.state.selectedLocation);
    }
    getFilteredEvents() {
        const { events } = this.props;
        const { selectedCategory, selectedPeriod, selectedLocation } = this.state;
        const filteredEvents = events
            .filter((event) => (!selectedCategory || event.category === selectedCategory) &&
            (!selectedLocation || this.isEventInSelectedLocation(event)) &&
            (selectedPeriod.month === "" || selectedPeriod.year === "" ||
                (moment(event.begin).month().toString() == selectedPeriod.month && moment(event.begin).year().toString() == selectedPeriod.year)))
            .sort((e1, e2) => moment(e1.begin).unix() - moment(e2.begin).unix());
        const eventsFilterdByTicket = this.filterByGiveFilterDates(filteredEvents);
        return this.sortEventsTickets(eventsFilterdByTicket);
    }
    sortEventsByTicketStartDate(events) {
        return events.sort((e1, e2) => {
            const e1Tickets = this.sortEventTicketsByStartDate(this.filterEventTickets(e1));
            const e2Tickets = this.sortEventTicketsByStartDate(this.filterEventTickets(e2));
            const e1FirstTicketDate = e1Tickets.length > 0 ? e1Tickets[0].date : null;
            const e2FirstTicketDate = e2Tickets.length > 0 ? e2Tickets[0].date : null;
            if (!e1FirstTicketDate && !e2FirstTicketDate) {
                return 0;
            }
            else if (e1FirstTicketDate && !e2FirstTicketDate) {
                return -1;
            }
            else if (!e1FirstTicketDate && e2FirstTicketDate) {
                return 1;
            }
            return moment(e1FirstTicketDate).unix() - moment(e2FirstTicketDate).unix();
        });
    }
    filterEventTickets(event) {
        const eventWithValidTickets = {
            ...event,
            tickets: event.tickets
                .filter(ticket => moment(ticket.date).startOf('day').isSameOrAfter(moment(Date.now()).startOf('day')))
        };
        return eventWithValidTickets.tickets; //.filter(ticket => ticket.link);
    }
    sortEventsTickets(events) {
        const masterProductions = this.getGroupedEvents(events);
        return masterProductions.map(event => {
            event.tickets = this.sortEventTicketsByStartDate(event.tickets);
            return event;
        });
    }
    /* Group event with different version of production and gather tickets in one event */
    getGroupedEvents(events) {
        let eventsWithMasterProductions = [];
        events.forEach((event) => {
            const existingEvent = eventsWithMasterProductions.find(e => e.link === event.link);
            if (existingEvent) {
                const filterOut = eventsWithMasterProductions.filter(pro => pro.link != event.link);
                eventsWithMasterProductions = [...filterOut, { ...existingEvent, tickets: [...event.tickets, ...existingEvent.tickets] }];
            }
            else {
                eventsWithMasterProductions.push(event);
            }
        });
        return eventsWithMasterProductions;
    }
    sortEventTicketsByStartDate(tickets) {
        return tickets.sort((a, b) => moment(a.date).unix() - moment(b.date).unix());
    }
}
exports.CultureProgram = CultureProgram;
function merge(newEvents, currentEvents) {
    if (newEvents.length === 0) {
        return currentEvents.map(ce => {
            const tickets = ce.tickets.map(ticket => {
                return { ...ticket, features: ce.features };
            });
            return { ...ce, tickets: tickets };
        });
    }
    return currentEvents.map(e => {
        e.tickets = e.tickets.map(t => {
            const newTicket = newEvents.find(ne => ne.key === t.id);
            if (!newTicket) {
                return t;
            }
            t.count = newTicket.ticket_left_count;
            t.countLow = newTicket.almost_sold_out;
            t.salesEnabled = newTicket.ticket_sales_enabled;
            t.salesActive = newTicket.ticket_sales_active;
            t.purchaseUrl = newTicket.purchase_url;
            t.features = e.features;
            return t;
        });
        return e;
    });
}
exports.default = react_redux_1.connect((state, ownProps) => ({
    events: merge(state.events.items, ownProps.events)
}), (dispatch) => ({
    eventActions: redux_1.bindActionCreators(events_1.actionCreators, dispatch)
}))(CultureProgram);



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-culture-program/CultureProgram.tsx